namespace TabAurous.ProductDevelopment {
    export interface StageMembersForm {
        MemberName: Serenity.StringEditor;
        Email: Serenity.EmailEditor;
        Comment: Serenity.BooleanEditor;
        Decision: Serenity.BooleanEditor;
        Manage: Serenity.BooleanEditor;
        Share: Serenity.BooleanEditor;
    }

    export class StageMembersForm extends Serenity.PrefixedContext {
        static formKey = 'ProductDevelopment.StageMembers';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!StageMembersForm.init)  {
                StageMembersForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.EmailEditor;
                var w2 = s.BooleanEditor;

                Q.initFormType(StageMembersForm, [
                    'MemberName', w0,
                    'Email', w1,
                    'Comment', w2,
                    'Decision', w2,
                    'Manage', w2,
                    'Share', w2
                ]);
            }
        }
    }
}
